module.exports = __webpack_public_path__ + "img/signature.743dd9e.jpg";